<template>
  <div>
    <!-- 弹窗 -->
    <Modal
      ref="modal"
      v-model="modal1"
      class="helperModal"
      :closable="false"
      width="1036px"
      @on-cancel="helpCancel"
      footer-hide
      :styles="{
        top: 'calc((100vh - 660px) / 2)'
      }"
    >
      <div class="header" style="margin-bottom: 15px;">
        <div style="display: flex; justify-content: space-between;">
          <!-- 标题 -->
          <div style="font-size: 20px; color: #111">
            {{ $t("help_center") }}
          </div>
          <!-- 搜索栏 -->
          <div
            class="search"
            tabindex="0"
            style="display:flex;outline:none; align-items: center;"
          >
            <div style="position:relative">
              <!-- 搜索输入框框 -->
              <Input
                ref="search"
                :placeholder="$t('help_center_detail.search_placeholder')"
                @on-focus="searchFocus"
                @on-blur="searchBlur"
                @on-keyup.enter="searchDocument"
                v-model.trim="search_keywords"
                clearable
                style="width: auto"
              >
                <Icon type="ios-search" slot="prefix" />
              </Input>
              <!-- 搜索历史 -->
              <div
                class="search_history"
                @mousedown="clickHistoryHandler"
                v-show="isShowHistory"
              >
                <!-- 历史记录 -->
                <div class="history" style="margin-top: 10px; margin-left:12px">
                  <h5 style="margin-bottom: 10px;">
                    {{ $t("help_center_detail.history") }}
                  </h5>
                  <div
                    class="tag"
                    @mousedown="clickHistory(item)"
                    v-for="(item, index) in history_list"
                    :key="item"
                    :name="item"
                  >
                    <span style="margin-right: 3px;">{{ item }}</span>
                    <div class="close" @mousedown="delete_history(index)">
                      <Icon refs="icon_close" size="18" type="ios-close" />
                    </div>
                  </div>
                </div>
                <!-- 分割线 -->
                <div
                  style="height:1px;margin: 10px 0; border: 1px #eee solid;"
                ></div>
                <!-- 清空历史记录 -->
                <div
                  class="clear_history"
                  style="display:flex;align-items: center;padding: 0px 12px 10px;"
                >
                  <div style="margin-right: 10px">
                    <img
                      style="vertical-align: middle;"
                      src="../../static/images/dustbin.svg"
                      alt=""
                    />
                  </div>
                  <div class="content" @mousedown="clearHistory">
                    {{ $t("help_center_detail.clear_the_history") }}
                  </div>
                </div>
              </div>
            </div>
            <Icon
              @click="modal1 = false"
              style="margin-left:15px;cursor: pointer;"
              type="md-close"
              size="25"
              slot="prefix"
            />
          </div>
        </div>
      </div>
      <div class="body" style="color: #333;font-size: 17px;">
        <!-- 首页 -->
        <div
          v-show="!currentName && !isSearch"
          style="width: 100%;height: 517px; display: flex;justify-content: space-around;align-items: center;"
        >
          <!-- 分类页 -->
          <div
            class="classification"
            @click="clickHandler(name)"
            v-for="name in icons"
            :key="name"
            style="display:flex;flex-direction: column; justify-items: center;align-items: center;"
          >
            <div style="margin-bottom: 15px;">
              <img :src="`../../static/images/${name}.svg`" alt="" />
            </div>
            <div>{{ $t(`help_center_detail.${name}`) }}</div>
          </div>
        </div>
        <!-- 面包屑 -->
        <div v-show="currentName || isSearch" style="margin-bottom: 15px;">
          <div style="text-align: left;">
            <Breadcrumb separator=">" style="color:rgba(153, 153, 153, 1);">
              <BreadcrumbItem
                @click.native="backHandler"
                style="font-size: 14px;color: "
                >{{ $t("help_center") }}</BreadcrumbItem
              >
              <BreadcrumbItem
                @click.native="backClassify"
                style="color:#333;font-size: 14px;"
                >{{ currentName }}</BreadcrumbItem
              >
              <BreadcrumbItem
                style="color:#333;font-size: 14px;"
                v-if="question"
                >{{ question }}</BreadcrumbItem
              >
            </Breadcrumb>
          </div>
        </div>

        <!-- 内容区 -->
        <div class="helper_container">
          <custom-scroll
            v-show="currentName"
            @scrollEnd="scrollEndHandler"
            @scroll="scrollHandler"
            ref="help_father"
            height="500px"
            class="help_father"
          >
            <!-- 有内容 -->
            <template v-if="contentList.length > 0">
              <template v-if="!answer">
                <div>
                  <!-- 如果currentName 有值则一定是点击分类 -->
                  <div
                    class="phase"
                    v-for="phase in phaseList"
                    :key="phase.stage"
                  >
                    <h2>{{ $t(`help_center_detail.${phase.stage}`) }}</h2>
                    <template v-for="role in user_roles">
                      <div v-if="phase[role].length > 0" :key="role">
                        <div
                          style="font-weight: 600;font-size: 25px;margin-bottom: 5px;"
                        >
                          {{ $t(`help_center_detail.${role}`) }}
                        </div>
                        <!-- 是否是搜索内容 -->
                        <template v-if="isSearch">
                          <div
                            style="margin-bottom: 20px; margin-left: 20px;"
                            v-if="user_manual_list(phase[role]).length > 0"
                          >
                            <!-- 用户使用手册 -->
                            <div
                              style="font-size: 20px; margin: 10px 0 5px;font-weight: 600;"
                            >
                              {{ $t("help_center_detail.user_manual") }}
                            </div>
                            <div
                              class="search_title"
                              v-for="content in user_manual_list(phase[role])"
                              :key="content.header.document_id"
                            >
                              <span
                                :data-el="
                                  `document_${content.header.document_id}`
                                "
                                @click="search_user_manual_skip($event, role)"
                              >
                                <text-highlight :queries="hight_words">
                                  {{
                                    content.title
                                      ? content.title
                                      : content.header.document_name
                                  }}
                                </text-highlight>
                              </span>
                            </div>
                          </div>

                          <!-- 视频 -->
                          <div
                            style="margin-bottom: 20px; margin-left: 20px;"
                            v-if="video_list(phase[role]).length > 0"
                          >
                            <div
                              style="font-size: 20px; margin: 10px 0 5px;font-weight: 600;"
                            >
                              {{
                                $t(
                                  "help_center_detail.feature_description_video"
                                )
                              }}
                            </div>
                            <div
                              class="search_title"
                              v-for="content in video_list(phase[role])"
                              :key="content.header.document_id"
                            >
                              <span
                                :data-el="
                                  `document_${content.header.document_id}`
                                "
                                @click="search_video_skip"
                              >
                                <text-highlight :queries="hight_words">
                                  {{
                                    content.title
                                      ? content.title
                                      : content.header.document_name
                                  }}
                                </text-highlight>
                              </span>

                              <!-- <span
                            :data-el="`document_${content.header.document_id}`"
                            @click="search_video_skip"
                            >{{
                              content.title
                                ? content.title
                                : content.header.document_name
                            }}</span -->
                              <!-- > -->
                            </div>
                          </div>
                          <div
                            style="margin-bottom: 20px; margin-left: 20px;"
                            v-if="faq_list(phase[role]).length > 0"
                          >
                            <!-- 常见问题 -->

                            <div
                              style="font-size: 20px; margin: 10px 0 5px;font-weight: 600;"
                            >
                              {{ $t("help_center_detail.FAQ") }}
                            </div>
                            <div
                              v-for="(content, index) in faq_list(phase[role])"
                              :key="content.header.document_id"
                              style="margin-bottom: 15px"
                            >
                              <div class="search_title">
                                <p
                                  @click="
                                    getDocumentDetail(
                                      content.header.document_id,
                                      index
                                    )
                                  "
                                  style="cursor: pointer;"
                                >
                                  <text-highlight :queries="hight_words">
                                    {{ content.title }}
                                  </text-highlight>
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                        <!-- 不是搜索内容 -->
                        <template v-else>
                          <!-- 用户使用手册 -->
                          <template
                            v-if="
                              currentName ==
                                $t('help_center_detail.user_manual')
                            "
                          >
                            <div class="user_manual" @click="previewImgHandler">
                              <div
                                v-for="document in user_manual_list(
                                  phase[role]
                                )"
                                :key="document.header.document_id"
                                :ref="`document_${document.header.document_id}`"
                                style="margin-bottom:20px;"
                                class="document_title"
                                :data-role="role"
                              >
                                <div
                                  style="margin-left: 18px; font-weight: 600;margin-bottom:5px;font-size: 25px;"
                                >
                                  <text-highlight :queries="hight_words">
                                    {{
                                      document.title
                                        ? document.title
                                        : document.header.document_name
                                    }}
                                  </text-highlight>
                                </div>
                                <div
                                  class="user_manual_content"
                                  style="margin-left: 18px;"
                                  v-if="document.content"
                                  v-html="document.content.content"
                                ></div>
                              </div>
                            </div>
                          </template>
                          <!-- 视频 -->
                          <template
                            v-else-if="
                              currentName ==
                                $t(
                                  'help_center_detail.feature_description_video'
                                )
                            "
                          >
                            <div class="content_wrap">
                              <div
                                class="item"
                                v-for="(video, index) in video_list(
                                  phase[role]
                                )"
                                :key="video.header.document_id"
                                :style="{
                                  marginRight:
                                    index + (1 % 4) == 0 && index != 0
                                      ? '0'
                                      : '14px'
                                }"
                                :ref="`document_${video.header.document_id}`"
                              >
                                <div
                                  class="video_cover"
                                  :style="{
                                    backgroundImage: `url(${
                                      video.media &&
                                      video.media[0] &&
                                      video.media[0].media_thumb_url
                                        ? video.media[0].media_thumb_url
                                        : '../../static/images/暂无图片1.svg'
                                    })`
                                  }"
                                >
                                  <div class="zoom"></div>
                                  <div class="play" @click="playVideo(video)">
                                    <img
                                      src="../../static/images/help_play.svg"
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <div class="video_title">
                                  <text-highlight :queries="hight_words">
                                    {{
                                      video.title
                                        ? video.title
                                        : video.header.document_name
                                    }}
                                  </text-highlight>
                                </div>
                                <div class="video_detail">
                                  <div>
                                    {{ video.header.created_on | formatDate }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <!-- 常见问题 -->
                          <template v-else>
                            <div class="faq" @click="previewImgHandler">
                              <div
                                v-for="(content, index) in faq_list(
                                  phase[role]
                                )"
                                :key="content.header.document_id"
                                style="margin-bottom: 15px"
                                :ref="`document_${content.header.document_id}`"
                                class="document_title"
                                :data-role="role"
                              >
                                <div class="question">
                                  <p
                                    @click="
                                      getDocumentDetail(
                                        content.header.document_id,
                                        index
                                      )
                                    "
                                    style="cursor: pointer;"
                                  >
                                    <text-highlight :queries="hight_words">
                                      {{ content.title }}
                                    </text-highlight>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="question">
                  <p style="font-size: 25px;margin-bottom: 35px;">
                    <text-highlight :queries="hight_words">
                      {{ question }}
                    </text-highlight>
                  </p>
                </div>
                <div
                  class="answer"
                  style="padding-right:35px;"
                  v-html="answer"
                ></div>
              </template>
            </template>
            <!-- 无内容 -->
            <template v-else>
              <div class="no_content">
                <div>
                  <img
                    :src="
                      `../../static/images/${
                        isSearch ? 'no_search' : 'no_content'
                      }.svg`
                    "
                    alt=""
                  />
                </div>
                <div>
                  {{
                    $t(
                      `help_center_detail.${
                        isSearch ? "no_search" : "no_content"
                      }`
                    )
                  }}
                </div>
              </div>
            </template>
          </custom-scroll>
          <!-- <div v-show="currentName" class="help_father" ref="help_father">


          </div> -->
          <!-- 滚动条 -->
          <!-- <div v-show="currentName" class="helper_vertical-scroll">
            <div class="help_rail"></div>
          </div> -->
          <!-- 询问弹窗 -->
          <div
            class="inquiry"
            ref="inquiry"
            :style="{
              justifyContent: isSolve === true ? 'center' : 'space-between'
            }"
          >
            <template v-if="isSolve !== true">
              <!--  -->
              <div style="display: flex;">
                <img
                  src="../../static/images/excl_mark.svg"
                  height="25px"
                  alt=""
                />
                <div
                  style="flex: 1;flex-wrap: wrap; margin: 0 10px;"
                  v-show="isSolve !== false"
                >
                  {{ $t("help_center_detail.solve_problem") }}
                </div>
                <div
                  style="flex: 1;flex-wrap: wrap; margin: 0 10px;"
                  v-show="isSolve === false"
                >
                  {{ $t("help_center_detail.send_email") }}
                  <a href="mailto: emoment.service@nike.com"
                    >emoment.service@nike.com</a
                  >
                </div>
                <Icon
                  type="md-close"
                  style="cursor: pointer;margin-top:5px;"
                  @click="closeInquiry"
                  color="#fff"
                  size="20"
                />
              </div>
              <!-- 按钮 -->
              <div style="text-align: right" v-show="isSolve !== false">
                <button
                  @click="isSolve = true"
                  style="color: #000; background: #fff;margin-right: 25px;"
                >
                  {{ $t("help_center_detail.solve_problem_ok") }}
                </button>
                <button style="color: #fff" @click="show_send_email">
                  {{ $t("help_center_detail.solve_problem_no") }}
                </button>
              </div>
              <div v-show="isSolve === false">
                <button
                  @click="closeInquiry"
                  style="width:100%;color: #000; background: #fff;margin-right: 25px;"
                >
                  {{ $t("help_center_detail.i_know") }}
                </button>
              </div>
            </template>
            <template v-else>
              <div
                style="display:flex; flex-direction: column;justify-content: center;align-items: center;"
              >
                <img
                  style="display:block; margin-bottom: 5px;"
                  src="../../static/images/笔芯.svg"
                  alt=""
                />
                <div>{{ $t("help_center_detail.feedback") }}</div>
                <Icon
                  type="md-close"
                  style="position:absolute;right:16px;top:10px;cursor: pointer;margin-top:5px;"
                  @click="closeInquiry"
                  color="#fff"
                  size="20"
                />
              </div>
            </template>
          </div>
        </div>
        <!-- 目录图标 -->
        <div
          class="catalog"
          v-show="currentName && !isSearch"
          @click="showCatalog"
        >
          <div
            :title="$t('help_center_detail.catalog')"
            style="display:flex; align-items: center;"
          >
            <img src="../../static/images/catalog.svg" alt="" />
          </div>
          <!-- <div>
            <span>{{ $t("litter_helper.catalog") }}</span>
          </div> -->
        </div>
        <Drawer
          ref="drawer"
          :closable="false"
          placement="left"
          v-model="isShowCatalog"
          width="310"
        >
          <div
            class="catalogDrawer"
            slot="header"
            style="font-weight: 600;font-size: 20px;color:#000"
          >
            <div>
              {{ $t("help_center_detail.catalog") }}
            </div>
            <Icon
              style="cursor: pointer"
              @click="isShowCatalog = false"
              size="30"
              type="ios-close"
            />
          </div>
          <div @click="catalogSkip">
            <div
              class="phase"
              style="margin-bottom: 15px;"
              v-for="phase in phaseList"
              :key="phase.stage"
            >
              <div
                style="font-size: 25px;font-weight: 600;margin-bottom: 10px;"
              >
                {{ $t(`help_center_detail.${phase.stage}`) }}
              </div>
              <template v-for="role in user_roles">
                <div v-if="phase[role].length > 0" :key="role">
                  <div
                    style="font-weight: 600;margin-left:18px; font-size: 20px;"
                  >
                    {{ $t(`help_center_detail.${role}`) }}
                  </div>
                  <!-- 用户使用手册 -->
                  <template
                    v-if="currentName == $t('help_center_detail.user_manual')"
                  >
                    <div
                      class="catalog_title"
                      style="margin-left: 38px;font-size: 18px;margin-bottom: 10px;"
                      v-for="content in user_manual_list(phase[role])"
                      :key="content.header.document_id"
                    >
                      <span
                        :class="{
                          catalogHight:
                            title_hight.text ===
                              (content.title
                                ? content.title
                                : content.header.document_name) &&
                            title_hight.parent === role
                        }"
                        :data-el="`document_${content.header.document_id}`"
                        >{{
                          content.title
                            ? content.title
                            : content.header.document_name
                        }}</span
                      >
                    </div>
                  </template>
                  <!-- 视频 -->
                  <template
                    v-else-if="
                      currentName ==
                        $t('help_center_detail.feature_description_video')
                    "
                  >
                    <div
                      class="catalog_title"
                      style="margin-left: 38px;font-size: 18px;margin-bottom: 10px;"
                      v-for="content in video_list(phase[role])"
                      :key="content.header.document_id"
                    >
                      <span
                        :data-el="`document_${content.header.document_id}`"
                        >{{
                          content.title
                            ? content.title
                            : content.header.document_name
                        }}</span
                      >
                    </div>
                  </template>
                  <!-- 常见问题 -->
                  <template v-else>
                    <div
                      class="catalog_title"
                      style="margin-left: 38px;font-size: 18px;margin-bottom: 10px;"
                      v-for="content in faq_list(phase[role])"
                      :key="content.header.document_id"
                    >
                      <span
                        :data-el="`document_${content.header.document_id}`"
                        :class="{
                          catalogHight:
                            title_hight.text ===
                              (content.title
                                ? content.title
                                : content.header.document_name) &&
                            title_hight.parent === role
                        }"
                        >{{ content.title }}</span
                      >
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </Drawer>
      </div>
    </Modal>
    <!-- 发送邮箱的弹框 -->
    <Modal
      footer-hide
      :closable="false"
      width="800px"
      :mask-closable="false"
      v-model="is_send_email"
      :styles="{
        top: 'calc((100vh - 660px) / 2)'
      }"
    >
      <div class="header" style="margin-bottom: 15px;">
        <div style="display: flex; justify-content: space-between;">
          <!-- 标题 -->
          <div style="font-size: 20px; color: #111">
            {{ $t("help_center_detail.faq_feedback") }}
          </div>
          <Icon
            @click="is_send_email = false"
            style="margin-left:15px;cursor: pointer;"
            type="md-close"
            size="25"
            slot="prefix"
          />
        </div>
      </div>
      <div>
        <Input
          v-model="send_email.question"
          type="textarea"
          :rows="6"
          :placeholder="$t('help_center_detail.enter_question')"
        />
      </div>
      <div style="margin-top: 20px;text-align: right;">
        <Button
          type="primary"
          @click="sendEmailHandler"
          style="margin-right:15px"
          >{{ $t("submit") }}</Button
        >
        <Button type="default" @click="is_send_email = false">{{
          $t("cancel")
        }}</Button>
      </div>
    </Modal>
    <!-- 视频弹窗 -->
    <Modal
      v-model="videoShow"
      draggable
      sticky
      scrollable
      :mask="false"
      :title="video_title"
      width="880px"
      @on-cancel="cancelVideoPlay"
    >
      <videoPlayer
        style="height: 495px;"
        playerWrapId="helpLitterVideo"
        ref="helpAliyunPlayer"
      ></videoPlayer>
      <div slot="footer"></div>
    </Modal>
    <!--黑色遮罩-->
    <div v-show="isPreviewImg" class="black_overlay" id="black_overlay"></div>

    <!--预览容器，存放点击放大后的图片-->
    <div v-show="isPreviewImg" class="enlargeContainer" id="enlargeContainer">
      <!-- 关闭按钮，一个叉号图片 -->
      <!-- <img src="./images/close.png" class="close" id="close" /> -->
      <img class="enlargePreviewImg" :src="previewImg" />
      <Icon
        class="previewClose"
        color="#fff"
        size="30"
        @click="isPreviewImg = false"
        type="md-close"
      />
    </div>
  </div>
</template>

<script>
import { user_search_help, get_help_detail } from "@/api/little_helper";
import { get_video_auth } from "@/api/media";
import videoPlayer from "@/components/video_player";

export default {
  name: "LitterHelper",
  components: {
    videoPlayer
  },
  data() {
    return {
      previewImg: "",
      isPreviewImg: false,
      videoShow: false,
      video_title: "",
      activeVideoInfo: {
        playauth: "",
        vid: ""
      },
      skip_label: "",
      hight_words: "",
      title_hight: {
        text: "",
        parent: ""
      },
      document_types: {
        user_manual: 0,
        feature_description_video: 1,
        FAQ: 2
      },
      //是否弹出弹框
      isShowInquiry: false,
      detail_list: [],
      isSolve: "",
      history_list: [],
      lang_list: {
        ENGLISH: "en-us",
        简体中文: "zh-cn",
        繁體中文: "zh-tw"
      },
      cancel: false,
      modal1: false,
      searchParams: {
        keywords: "",
        type: "",
        language_code:
          this.lang_list && this.lang_list[this.$store.state.language],
        page_size: 999,
        page_index: 1
      },
      // isInitScroll: false,
      isShowCatalog: false,
      isSearch: false,
      contentList: [],
      currentName: "",
      question: "",
      answer: "",
      answerIndex: 0,
      isShowHistory: false,
      isScroll: false,
      icons: ["user_manual", "feature_description_video", "FAQ"],
      phaseList: [
        {
          stage: "preparatory_phase",
          document_stage_code: 0,
          content: [],
          general: [],
          system_admin: [],
          event_admin: [],
          broadcaster: [],
          partner_contactor: [], //pc
          assistant: [], //产品专家
          speaker: [], //讲者
          attendee: [] // 参会人
        },
        {
          stage: "registration_phase",
          document_stage_code: 10,
          content: [],
          general: [],
          system_admin: [],
          event_admin: [],
          broadcaster: [],
          partner_contactor: [], //pc
          assistant: [], //产品专家
          speaker: [], //讲者
          attendee: [] // 参会人
        },
        {
          stage: "activity_phase",
          document_stage_code: 20,
          content: [],
          general: [],
          system_admin: [],
          event_admin: [],
          broadcaster: [],
          partner_contactor: [], //pc
          assistant: [], //产品专家
          speaker: [], //讲者
          attendee: [] // 参会人
        },
        {
          stage: "activity_end",
          document_stage_code: 30,
          content: [],
          general: [],
          system_admin: [],
          event_admin: [],
          broadcaster: [],
          partner_contactor: [], //pc
          assistant: [], //产品专家
          speaker: [], //讲者
          attendee: [] // 参会人
        }
      ],
      user_roles: [
        "general",
        "system_admin",
        "event_admin",
        "broadcaster",
        "partner_contactor",
        "assistant",
        "speaker",
        "attendee"
      ],
      count: [0, 1, 2, 3, 4, 5],
      search_keywords: "",
      isClickHistory: false,
      skipInfo: {
        target: {
          dataset: { el: null },
          innerText: ""
        }
      },
      is_send_email: false,
      send_email: {
        email: this.$store.state.user_info.login_email,
        question: ""
      }
    };
  },

  computed: {
    user_manual_list() {
      return content => {
        // console.log(content, "元数据")
        // console.log(content.filter(item => item.header.document_type == 0), "处理数据")
        return content.filter(item => item.header.document_type == 0);
      };
    },
    video_list() {
      return content => {
        // console.log(content, "this.skipInfo.target.dataset.innerTextthis.skipInfo.target.dataset.innerText")
        return content.filter(
          item =>
            item.header.document_type == 1 &&
            item.media &&
            item.media.length > 0
        );
      };
    },
    faq_list() {
      return content => {
        return content.filter(item => item.header.document_type == 2);
      };
    }
  },
  watch: {
    search_keywords(newVal) {
      this.hight_words = newVal;
      // console.log(this.high_word)
    },
    phaseList: {
      handler() {
        // this.initContentWrap();
      },
      deep: true
    },
    modal1(newVal) {
      if (newVal === false) {
        this.helpCancel();
        this.hiddenInquiry();
      }
    }
  },

  mounted() {
    if (localStorage.getItem("history")) {
      this.history_list = JSON.parse(localStorage.getItem("history"))[
        this.$store.state.user_info.user_code
      ];
    }
  },

  methods: {
    sendEmailHandler() {
      console.log(this.send_email.email);
    },
    show_send_email() {
      this.is_send_email = true;
      this.send_email.question = "";
    },
    // 滚动条事件
    scrollHandler(e) {
      const title_list = document.querySelectorAll(".document_title");
      if (title_list.length <= 0) return;
      // console.log(document.querySelectorAll(".document_title"))
      // console.log(title_list);
      // console.log(e);
      const hight_light_item = Array.from(title_list).find(
        node =>
          node.offsetTop - e.target.scrollTop >= 0 &&
          node.offsetTop - e.target.scrollTop <= 88
      );
      // console.dir(hight_light_item);
      if (!hight_light_item) return;
      this.title_hight.text = hight_light_item.children[0].innerText;
      this.title_hight.parent = hight_light_item.dataset.role;
      // console.log(this.title_hight);
    },
    hiddenInquiry() {
      this.$refs.help_father.$el.scrollTop = 0;
      this.$refs.inquiry.style.opacity = 0;
    },
    scrollEndHandler() {
      this.isSolve = "";
      if (this.$refs.help_father.$el.scrollTop !== 0) {
        this.$refs.inquiry.style.opacity = 1;
      }
    },
    previewImgHandler(e) {
      if (e.target.tagName !== "IMG") return;
      this.previewImg = e.target.src;
      this.$hevueImgPreview({url:e.target.src})
      // this.isPreviewImg = true;
      // console.log(e)
    },
    // 搜索到的视频标题进行跳转
    search_video_skip(e) {
      this.clickHandler("feature_description_video");
      let target = e.path.find(item => item.dataset.el);
      // console.log(target.dataset.el);
      this.skip_label = target.dataset.el;
      this.skipInfo.target.dataset.el = this.skip_label;
      this.skipInfo.target.innerText = e.target.innerText.trim();
    },
    // 用户使用手册跳转
    search_user_manual_skip(e, role) {
      this.clickHandler("user_manual");
      this.title_hight.parent = role;
      let target = e.path.find(item => item.dataset.el);
      this.skip_label = target.dataset.el;
      this.skipInfo.target.dataset.el = this.skip_label;
      this.skipInfo.target.innerText = e.target.innerText.trim();
    },
    // 给目录添加点击事件， 做锚点跳转
    catalogSkip(e) {
      if (e.target.dataset.el) {
        this.$nextTick(() => {
          let offsetTop = this.$refs[e.target.dataset.el][0].offsetTop;
          const maxScrollTop =
            this.$refs.help_father.$el.scrollHeight -
            this.$refs.help_father.$el.clientHeight;
          if (offsetTop > maxScrollTop) {
            offsetTop = maxScrollTop;
          }
          this.$refs.help_father.$el.scrollTop = offsetTop;
          console.log(e.target);
          this.hight_words = e.target.innerText.trim();
          this.isShowCatalog = false;
          // console.log("我跳转");
        });
      }
    },
    cancelVideoPlay() {
      this.$refs.helpAliyunPlayer.dispose(); //销毁
    },
    closeInquiry() {
      this.$refs.inquiry.style.opacity = 0;
    },
    helpCancel() {
      this.currentName = "";
      this.searchParams.keywords = "";
      this.searchParams.type = "";
      this.question = "";
      this.answer = "";
      this.isSearch = false;
      this.hight_words = "";
      this.skip_label = null;
    },
    // 播放视频
    playVideo(video) {
      console.log(video);

      if (video.media[0]) {
        get_video_auth({ media_id: video.media[0].media_id }).then(res => {
          this.video_title = res.body.media_title;
          // console.log(res, "resresresresres")
          this.videoShow = true;
          this.activeVideoInfo.playauth = res.body.play_auth;
          this.activeVideoInfo.vid = res.body.video_id;
          this.$refs.helpAliyunPlayer.initAliyunPlayer(this.activeVideoInfo);
        });
      }
    },
    // 搜索文档
    searchDocument() {
      this.searchParams.keywords = this.search_keywords;
      this.searchParams.type = "";
      this.isSearch = true;
      this.currentName = this.$t("search");
      this.question = "";
      this.answer = "";
      this.hight_words = "";
      this.title_hight = this.$options.data.call(this).title_hight;
      this.skip_label = "";
      if (
        this.search_keywords !== "" &&
        !this.history_list.find(item => item === this.search_keywords)
      ) {
        this.history_list.push(this.search_keywords);
        localStorage.setItem(
          "history",
          JSON.stringify({
            [this.$store.state.user_info.user_code]: this.history_list
          })
        );
      }
      this.user_search_help();
      this.$nextTick(() => {
        this.$refs.help_father.$el.scrollTop = 0;
      });
    },
    // 获取答案
    getDocumentDetail(document_id, index) {
      // console.log(this.$store.state.lang);
      let params = {
        document_id,
        language_code:
          this.lang_list && this.lang_list[this.$store.state.language]
      };
      if (index !== undefined) {
        this.answerIndex = index;
      }
      get_help_detail(params).then(res => {
        this.answer = res.body.content.content;
        this.question = res.body.content.title;
        this.title_hight.text = res.body.content.title;
        this.title_hight.parent = role;
        // this.initContentWrap();
      });
    },
    get_user_role(obj) {
      return obj.document_user_role == null
        ? "general"
        : this.user_roles[obj.document_user_role + 1];
    },
    // 获取内容
    user_search_help(payload) {
      this.searchParams.language_code =
        this.lang_list && this.lang_list[this.$store.state.language];
      user_search_help(this.searchParams).then(res => {
        // this.hight_words = "";
        this.contentList = res.body;
        this.phaseList.forEach(item => {
          item.content = [];
          item.system_admin = [];
          item.event_admin = [];
          item.broadcaster = [];
          item.partner_contactor = [];
          item.assistant = [];
          item.speaker = [];
          item.attendee = [];
          item.general = [];
        });
        // 把内容添加到对应的阶段
        this.phaseList.forEach(item => {
          res.body.forEach(document => {
            if (
              item.document_stage_code == document.header.document_stage_code
            ) {
              item.content.push(document);
            }
          });
        });
        // 获取文档详情， 只有用户使用手册和视频里面才会获取
        if (this.searchParams.type === 0 || this.searchParams.type === 1) {
          let get_detail_list = res.body.map(item =>
            get_help_detail({
              language_code:
                this.lang_list && this.lang_list[this.$store.state.language],
              document_id: item.header.document_id
            })
          );
          Promise.all(get_detail_list).then(res => {
            // console.log(res, "get_detail_listget_detail_list");

            this.phaseList.forEach(item => {
              item.content = [];
              item.system_admin = [];
              item.event_admin = [];
              item.broadcaster = [];
              item.partner_contactor = [];
              item.assistant = [];
              item.speaker = [];
              item.attendee = [];
              item.general = [];
            });
            this.phaseList.forEach(item => {
              res.forEach(document => {
                if (
                  item.document_stage_code ==
                  document.body.header.document_stage_code
                ) {
                  item.content.push(document.body);
                }
              });
            });
            // console.log(this.phaseList);
            // 把内容分到对应的角色
            this.phaseList.forEach(item => {
              item.content.forEach(o => {
                if (o.header.document_user_role === 0) {
                  item.system_admin.push(o);
                }
                if (o.header.document_user_role === 1) {
                  item.event_admin.push(o);
                }
                if (o.header.document_user_role === 2) {
                  item.attendee.push(o);
                }
                if (o.header.document_user_role === 3) {
                  item.broadcaster.push(o);
                }
                if (o.header.document_user_role === 4) {
                  item.partner_contactor.push(o);
                }
                if (o.header.document_user_role === 5) {
                  item.speaker.push(o);
                }
                if (o.header.document_user_role === 6) {
                  item.assistant.push(o);
                }
                if (o.header.document_user_role === null) {
                  item.general.push(o);
                }
              });
            });
          });
        } else {
          // 把内容分到对应的角色
          this.phaseList.forEach(item => {
            item.content.forEach(o => {
              if (o.header.document_user_role === 0) {
                item.system_admin.push(o);
              }
              if (o.header.document_user_role === 1) {
                item.event_admin.push(o);
              }
              if (o.header.document_user_role === 2) {
                item.attendee.push(o);
              }
              if (o.header.document_user_role === 3) {
                item.broadcaster.push(o);
              }
              if (o.header.document_user_role === 4) {
                item.partner_contactor.push(o);
              }
              if (o.header.document_user_role === 5) {
                item.speaker.push(o);
              }
              if (o.header.document_user_role === 6) {
                item.assistant.push(o);
              }
              if (o.header.document_user_role === null) {
                item.general.push(o);
              }
            });
          });
        }
        if (payload === "showContent") {
          this.title_hight.text =
            res.body[0].title || res.body[0].header.document_name;
        }
        setTimeout(() => {
          if (this.skip_label) {
            this.catalogSkip(this.skipInfo);
            // this.skip_label = null;
          } else {
            this.title_hight.parent = this.get_user_role(res.body[0]);
          }
        }, 1000);
      });
    },

    // 显示目录
    showCatalog() {
      this.isShowCatalog = true;
      this.$nextTick(() => {
        const container = document.querySelector(
          ".helperModal .ivu-drawer-body"
        );
        const title_list = Array.from(
          document.querySelectorAll(".catalog_title")
        );
        // console.log(title_list)
        const hight_item = title_list.find(
          node => node.innerText == this.title_hight.text
        );
        if (!hight_item) return;
        console.dir(hight_item);
        let offsetTop = hight_item.offsetTop;
        const maxScrollTop = container.scrollHeight - container.clientHeight;
        if (offsetTop > maxScrollTop) {
          offsetTop = maxScrollTop;
        }
        container.scrollTop = offsetTop;
        console.log(container.scrollTop);
      });
      // this.$refs.catalogDrawer.style.width = "300px";
    },
    // 关闭目录
    closeCatalog() {
      this.isShowCatalog = false;
      // this.$refs.catalogDrawer.style.width = 0;
    },
    // 返回助手页
    backHandler() {
      this.currentName = "";
      this.searchParams.keywords = "";
      this.searchParams.type = "";
      this.question = "";
      this.answer = "";
      this.hight_words = "";
      this.isShowInquiry = "";
      this.skip_label = "";
      this.isSearch = false;
      this.title_hight.text = this.$options.data.call(this).title_hight;
      this.hiddenInquiry();
    },
    //返回问题页
    backClassify() {
      // this.currentName = this.$t(`litter_helper.FAQ`);
      this.answer = "";
      this.question = "";
      this.hight_words = "";
      this.$nextTick(() => {
        const title_list = document.querySelectorAll(".document_title");
        this.title_hight.text = title_list[0].children[0].innerText;
      });
      this.hiddenInquiry();
      // this.initContentWrap();
    },
    // 显示分内容
    clickHandler(name) {
      this.helpCancel();
      this.currentName = this.$t(`help_center_detail.${name}`);
      this.searchParams.type = this.document_types[name];
      this.searchParams.keywords = "";
      // this.answer = "";
      // this.question = "";
      // this.initContentWrap();
      this.user_search_help("showContent");
      // this.isInitScroll = true;
    },
    showLittleHelp() {
      this.modal1 = true;
      this.helpCancel();
      this.search_keywords = "";
      this.$refs.modal.$el
        .querySelector(".ivu-modal-content")
        .appendChild(this.$refs.drawer.$el); //把抽屉添加到弹窗内
    },
    // 选择历史记录
    clickHistory(item) {
      this.search_keywords = item + "";
    },
    // 删除单个历史记录
    delete_history(index) {
      // console.log(index);
      this.history_list.splice(index, 1);
      localStorage.setItem(
        "history",
        JSON.stringify({
          [this.$store.state.user_info.user_code]: this.history_list
        })
      );
      // this.isClickHistory = true
    },
    // 清空历史记录
    clearHistory() {
      // this.isClickHistory = true
      this.history_list = [];
      localStorage.setItem(
        "history",
        JSON.stringify({
          [this.$store.state.user_info.user_code]: this.history_list
        })
      );
    },
    // 搜索框失去焦点
    searchBlur() {
      if (!this.isClickHistory) {
        this.isShowHistory = false;
      } else {
        this.$refs.search.focus();
      }
    },
    // 搜索历史框聚焦
    searchFocus() {
      this.isClickHistory = false;
      this.isShowHistory = true;
    },
    // 判断搜索历史框是否被点击
    clickHistoryHandler() {
      this.isClickHistory = true;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-btn-primary {
  background: #111111;
  border-color: #fff;
  color: #fff;

  &:hover {
    background: #fff;
    border-color: #000;
    color: #111111;
  }
}
/deep/.user_manual img,
/deep/ .faq img {
  cursor: pointer;
}
/*关闭预览*/
.previewClose {
  position: absolute;
  top: 60px;
  right: 80px;
  // width: 20px;
  // height: 20px;
  cursor: pointer;
  z-index: 189901;
}
.black_overlay {
  // display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 189900;
}

.enlargePreviewImg {
  /*这里我设置的是：预览后放大的图片相对于整个页面定位*/
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /*宽度设置为页面宽度的70%，高度自适应*/
  width: 70%;
  z-index: 199900;
}
/deep/ .user_manual_content {
  padding-right: 35px;
  p {
    line-height: 30px;
  }
}
/deep/ .ivu-drawer-header {
  padding: 0;
}
/deep/ .catalogDrawer {
  display: flex;
  padding: 16px;
  padding-top: 10px;
  padding-bottom: 5px;
  position: relative;
  justify-content: space-between;
  align-items: center;
}
/deep/ .catalog_title {
  span {
    transition: all 0.5s;
    &:hover {
      color: rgb(12, 159, 218);
      cursor: pointer;
    }
  }
}
/deep/ .catalogHight {
  background: #58a8fd5e;
}
/deep/ .ivu-drawer-wrap {
  position: absolute;
}
/deep/ .ivu-drawer {
  color: #333;
  position: absolute;
  // border-radius: 5px;
  .ivu-drawer-content {
    border-radius: 6px;
  }
}
/deep/ .text__highlight {
  background: #58a8fd5e;
}
.helperModal {
  /deep/ .ivu-modal-body {
    height: 660px !important;
    padding: 30px 20px 20px 55px;
    position: relative;
    // padding-right: 20px;
  }
}
.help {
  position: fixed;
  z-index: 999;
  right: 40px;
  bottom: 40px;
}
.search {
  // &:focus .history{
  //   display: block;
  // }
  .search_history {
    position: absolute;
    // display: none;
    left: 0;
    top: 33px;
    border-radius: 8px;
    box-shadow: 0px 9px 20px 8px rgba(0, 0, 0, 0.08);
    width: 100%;
    border: 1px #ccc solid;
    background: #fff;
    z-index: 999;
    .tag {
      display: inline-flex;
      align-items: center;
      font-size: 12px;
      line-height: 20px;
      border-radius: 40px;
      padding: 4px 8px;
      margin: 5px 4px 5px 0px;
      background: #f1f1f1;
      cursor: pointer;
      .close {
        height: 20px;
        /deep/ .ivu-icon-ios-close {
          margin-top: 1px;
          border-radius: 50%;
          transition: all 0.5s;
          &:hover {
            background: #fff;
          }
        }
      }
    }
    .clear_history {
      height: 30px;
      .content {
        cursor: pointer;
        transition: all 0.5s;
        &:hover {
          color: rgb(12, 159, 218);
        }
      }
    }
  }
}
.body {
  .title {
    cursor: pointer;
    margin: 15px 0;

    &:hover {
      color: rgb(68, 109, 253);
    }
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 15px;
      line-height: 25.5px;
      background: rgb(68, 109, 253);
      border-radius: 50%;
    }
  }
  /deep/ .ivu-breadcrumb {
    font-size: 20px;
    & > span:not(:last-child) {
      .ivu-breadcrumb-item-link {
        transition: all 0.5s;
        &:hover {
          cursor: pointer;
          color: rgb(12, 159, 218);
        }
      }
    }
    & > span:last-child {
      & > span:first-child {
        display: inline-block;
        width: 200px;
      }
      //   line-height: 14px;
      //   vertical-align: middle;
      overflow: hidden;
      //   /*文本不会换行*/
      white-space: nowrap;
      //   /*当文本溢出包含元素时，以省略号表示超出的文本*/
      text-overflow: ellipsis;
    }
  }
  .classification {
    width: 220px;
    border-radius: 8px;
    padding: 20px;
    transition: all 0.5s;
    &:hover {
      cursor: pointer;
      box-shadow: 0px 0px 13px 0px rgba(119, 115, 112, 1);
    }
  }
  // 内容容器
  .helper_container {
    height: 100%;
    // border: 1px #ccc solid;
    // border-radius: 5px;
    overflow: hidden;
    position: relative;

    .help_father {
      // overflow: scroll;
      position: relative;
      // padding-left: 48px;
      height: calc(661px - 144px);
      // margin-bottom: -17px;
      // margin-right: -17px;
      /deep/ .answer p {
        line-height: 40px;
      }
      .phase {
        margin-bottom: 25px;

        h2 {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          &::before {
            content: "";
            margin-right: 8px;
            display: block;
            width: 4px;
            height: 30px;
            background: #333;
          }
        }
        .question,
        .search_title {
          display: flex;
          align-items: center;
          height: 20px;
          &::before {
            content: "";
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: rgb(12, 159, 218);
            margin-right: 10px;
          }
          & > p {
            transition: all 0.5s;
            margin-top: 0;
            &:hover {
              color: rgb(12, 159, 218);
            }
          }
          span {
            transition: all 0.5s;
            &:hover {
              color: rgb(12, 159, 218);
              cursor: pointer;
            }
          }
        }
        .search_title {
          margin-left: 10px;
          margin: 5px 0;
        }
        .content_wrap {
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
            margin-bottom: 15px;
            width: 224px;
            height: 197px;
            margin-right: 14px;
            border: 1px #ccc solid;
            padding-bottom: 10px;

            .video_cover {
              width: 224px;
              height: 126px;
              position: relative;
              background: no-repeat center center;
              background-size: cover;
              flex-shrink: 0;
              &:hover .zoom {
                opacity: 0.5;
              }
              &:hover .play {
                opacity: 0.5;
              }
              .zoom {
                opacity: 0;
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: #000;
                transition: all 0.5s;
              }
              .play {
                position: absolute;
                z-index: 56;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                opacity: 0;
                cursor: pointer;
                transition: all 0.5s;
              }
              // margin-bottom: 15px;
            }
            .video_title {
              width: 224px;
              padding-left: 10px;
              margin: 10px 0;
              text-align: left;
              flex-shrink: 0;
              overflow: hidden;
              /*文本不会换行*/
              white-space: nowrap;
              /*当文本溢出包含元素时，以省略号表示超出的文本*/
              text-overflow: ellipsis;
            }
            .video_detail {
              align-items: center;
              text-align: left;
              display: flex;
              padding-left: 10px;

              font-size: 12px;
              color: #666;
            }
          }
        }
      }
      .no_content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .helper_vertical-scroll {
      position: absolute;
      right: 0;
      width: 8px;
      top: 0;
      transition: all 0.3s ease-out;
      visibility: visible;
      background-color: #f5f5f5;
      height: 100%;
      border-radius: 1000px;
    }
    .help_rail {
      width: 100%;
      height: 100%;
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background-color: #ccc;
      border-radius: 1000px;
      cursor: pointer;
      -webkit-transition: background-color 0.3s;
      transition: background-color 0.3s;
    }
    .inquiry {
      position: absolute;
      transition: all 0.5s;
      display: flex;
      flex-direction: column;
      // justify-content: ;
      // align-items: center;
      right: 8px;
      bottom: 8px;
      // width: 0px;
      opacity: 0;
      width: 352px;
      height: 123px;
      background: rgba(0, 0, 0, 0.6);
      border-left: 3px solid rgba(222, 103, 18, 1);
      color: #fff;
      padding: 16px;
      button {
        border: 1px solid #fff;
        background: none;
        padding: 3px 8px;
        cursor: pointer;
        border-radius: 5px;
      }
    }
  }

  // 目录
  .catalog {
    background: #000;
    display: flex;
    flex-direction: column;
    left: 0;
    top: 28px;
    width: 45px;
    align-items: center;
    cursor: pointer;
    justify-content: space-around;
    padding: 6px 0px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    position: absolute;
    border-radius: 0 5px 5px 0;
  }
}

/deep/ .search input {
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/litter_helper.vue